class FilterSelectController {

  constructor($timeout) {
    this.$timeout = $timeout;
  }

  $onInit() {
    var self = this;
    self.optionsInner = angular.copy(this.options);
    self.optionsInner.unshift({id: -1, name:'All'});
    self.value = self.optionsInner[0].id;
  }
}
FilterSelectController.$inject = ['$timeout'];
export default FilterSelectController;
